import { render, staticRenderFns } from "./quick-reply-list.vue?vue&type=template&id=59c80d64&scoped=true"
import script from "./quick-reply-list.vue?vue&type=script&lang=js"
export * from "./quick-reply-list.vue?vue&type=script&lang=js"
import style0 from "./quick-reply-list.vue?vue&type=style&index=0&id=59c80d64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c80d64",
  null
  
)

export default component.exports